import React from 'react'

// Components
import ProductListWithTitleAndPaginationComponent from '~/components/ProductListWithTitleAndPagination'

const SalePage = (props) => <ProductListWithTitleAndPaginationComponent {...props} />

export default SalePage
